import {
  AuditDateProps,
  GetAuditLogDetailsType,
} from '../../../../../types/Invoicing/InvoiceAuditLog/invoiceAuditLogtype'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  invoiceAuditLogListApiConfig,
} from '../../../apiList'

const getInvoiceAuditLogList = async (
  props: AuditDateProps,
): Promise<GetAuditLogDetailsType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoiceAuditLogListApiConfig.getAuditLogList,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex,
      enddate: (props.enddate as string) ?? null,
      firstIndex: props.firstIndex,
      invoiceDatePeriod: props.invoiceDatePeriod,
      startdate: (props.startdate as string) ?? null,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const auditLogDetailsListApi = {
  getInvoiceAuditLogList,
}

export default auditLogDetailsListApi
